<template>
  <div>
    <b-loading :active.sync="loading" />
    <div class="w-full flex justify-between items-start">
      <Lynx-Title text="Divisão de Receita" />
      <Lynx-Button
        text="Atualizar"
        class="mb-4"
        icon="Reload"
        @click.native="fetchData"
        size="small"
        icon-size="3"
      />
      <Lynx-Button
        text="Relatorio"
        class="mb-4"
        @click.native="gerarRelatorio()"
        size="small"
        icon-size="3"
      />
    </div>

    <div class="w-full flex justify-between items-end pb-6">
      <label class="w-1/4">
        <Lynx-Label label="ID Empresas" class=" " />

        <input
          class="border-primary-200 bg-white px-2 border-l-4 border-solid rounded py-1 w-full transition focus:shadow focus:border-r-4 font-light"
          v-model="empresas_id"
          v-on:keyup.enter="fetchData"
        />
      </label>
      <label class=" ">
        <Lynx-Label label="Por paginas" class=" " />

        <b-select v-model="filtros.perPage">
          <option
            :value="perPageOption"
            v-for="perPageOption in perPageOptions"
            :key="perPageOption"
          >
            {{ perPageOption }}
          </option>
        </b-select>
      </label>
    </div>
    <b-table
      :loading="loading"
      backend-pagination
      @page-change="onPageChange"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
      :data="loading ? [] : data"
      :columns="columns"
      :paginated="true"
      default-sort-direction="asc"
      default-sort="id"
      :total="pagination.total"
      :current-page="pagination.current_page"
      :per-page="pagination.per_page"
      hoverables
      striped
      class="w-full"
    >
      <template slot-scope="props">
        <b-table-column field="id" v-text="props.row.id" />
        <b-table-column field="nome" v-text="props.row.razao_social" />
        <b-table-column field="acoes">
          <div class="flex text-sm items-center">
            <a
              href="#"
              class="mr-4 bg-primary-600 rounded-full p-2"
              @click.prevent="openEditModal(props.row)"
            >
              <Icon-Edit class="text-neutral-100" size="4" />
            </a>
          </div>
        </b-table-column>
      </template>
    </b-table>
    <b-modal @close="closeEditModal" v-if="editModal" :active.sync="editModal">
      <DivisaoReceitaEdit :empresa="currentEmpresa" />
    </b-modal>
  </div>
</template>

<script>
import { allEmpresasRequest } from "@/services/requests/empresas";
import DivisaoReceitaEdit from "@/views/receitas/DivisaoReceitaEdit";

export default {
  name: "DivisaoReceita",
  components: { DivisaoReceitaEdit },
  data() {
    return {
      loading: false,
      editModal: false,
      columns: [
        {
          field: "id",
          label: "Número da empresa",
          searchable: true,
          sortable: true,
        },
        {
          field: "nome",
          label: "Nome da empresa",
          searchable: true,
          sortable: true,
        },
        {
          field: "acoes",
          label: "Ações",
        },
      ],
      filtros: {
        page: 1,
        empresas_id: null,
        perPage: 10,
        status: null,
      },
      data: [],
      currentEmpresa: null,
      pagination: {},

      perPageOptions: [10, 50, 100],
      current_page: 1,
    };
  },
  mounted() {
    this.fetchData();
  },
  watch: {
    "filtros.perPage"() {
      this.fetchData();
    },
    current_page() {
      this.filtros.page = this.current_page;
      this.fetchData();
    },
  },
  methods: {
    async fetchData() {
      this.loading = true;
      if (this.empresas_id) {
        this.filtros.empresas_id = this.empresas_id.split(",");
      } else {
        this.filtros.empresas_id = null;
      }

      const { filtros } = this;
      await allEmpresasRequest(filtros)
        .then((res) => {
          this.data = res.data.data;
          this.pagination = res.data.pagination;
        })
        .catch(() =>
          this.$snack.error("Ocorreu um erro, tente novamente mais tarde")
        )
        .finally(() => (this.loading = false));
    },

    gerarRelatorio() {
      window.open(
        `${process.env.VUE_APP_API_URL}/receitas/divisao-relatorio/?token=${this.$store.getters.getToken}`,
        "_blank"
      );
    },
    openEditModal(empresa) {
      this.currentEmpresa = empresa;
      this.editModal = true;
    },
    closeEditModal() {
      this.currentEmpresa = null;
      this.editModal = false;
    },
    onPageChange(page) {
      this.current_page = page;
    },
  },
};
</script>

